import React, { useState } from "react";
import MainCalculatorsList from "../MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds,MobileUnderCalAds } from "../../Ads";
import { CalculatorsType } from "../ConstantsEN";
import SharedHelmet from "../Helmet";
import {
  Button,
  FormControlLabel,
  Paper,
  Radio,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
} from "@mui/material";
const TITLE = "Online Time Calculator - Calculate Time and Duration";
const DESCRIPTION = "The free Time and Duration Calculator helps you add or subtract time values in terms of days, hours, minutes, or seconds with ease. You can also learn various concepts of time.";
const KEYWORDS = "calculator, time, duration, addition, subtraction, days, hours, minutes, seconds, concepts, conversion, computed, free";
const OG_URL = 'https://do-calculate.com/calculator/en/time-calculator';
function TimeCalculator() {
  const [day1, setDay1] = useState("");
  const [hour1, setHour1] = useState("");
  const [minute1, setMinute1] = useState("");
  const [second1, setSecond1] = useState("");
  const [day2, setDay2] = useState("");
  const [hour2, setHour2] = useState("");
  const [minute2, setMinute2] = useState("");
  const [second2, setSecond2] = useState("");
  const [type, setType] = useState("add");
  const [resultDay, setResultDay] = useState("");
  const [resultHour, setResultHour] = useState("");
  const [resultMinute, setResultMinute] = useState("");
  const [resultSecond, setResultSecond] = useState("");
  const handleDay1Change = (event) => {
    setDay1(event.target.value);
  };
  const handleHour1Change = (event) => {
    setHour1(event.target.value);
  };
  const handleMinute1Change = (event) => {
    setMinute1(event.target.value);
  };
  const handleSecond1Change = (event) => {
    setSecond1(event.target.value);
  };
  const handleDay2Change = (event) => {
    setDay2(event.target.value);
  };
  const handleHour2Change = (event) => {
    setHour2(event.target.value);
  };
  const handleMinute2Change = (event) => {
    setMinute2(event.target.value);
  };
  const handleSecond2Change = (event) => {
    setSecond2(event.target.value);
  };
  const handleCalculateTime = () => {
    const totalSeconds1 =
      (parseInt(day1) || 0) * 24 * 60 * 60 +
      (parseInt(hour1) || 0) * 60 * 60 +
      (parseInt(minute1) || 0) * 60 +
      (parseInt(second1) || 0);
    const totalSeconds2 =
      (parseInt(day2) || 0) * 24 * 60 * 60 +
      (parseInt(hour2) || 0) * 60 * 60 +
      (parseInt(minute2) || 0) * 60 +
      (parseInt(second2) || 0);
    let resultSeconds;
    if (type === "add") {
      resultSeconds = totalSeconds1 + totalSeconds2;
    } else if (type === "subtract") {
      resultSeconds = totalSeconds1 - totalSeconds2;
    }
    const days = Math.floor(resultSeconds / (24 * 60 * 60));
    const hours = Math.floor((resultSeconds % (24 * 60 * 60)) / (60 * 60));
    const minutes = Math.floor((resultSeconds % (60 * 60)) / 60);
    const seconds = resultSeconds % 60;
    setResultDay(days.toString());
    setResultHour(hours.toString());
    setResultMinute(minutes.toString());
    setResultSecond(seconds.toString());
  };
  return (
    <div>
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
                    <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  This calculator can be used to "add" or "subtract" two time
                  values. Input fields can be left blank, which will be taken as
                  0 by default.
                </p>
              </div>
              <br />
            </div>
            <hr />
            <MobileUnderCalAds/>
            <div className="row">
              <div className="col-sm-12 col-md-4">
                <label
                  htmlFor="dateOfBirth"
                  style={{ fontSize: "18px", fontWeight: "bold" }}
                >
                  Enter the time
                </label>
              </div>
              <div className="col-sm-12 col-md-4">
                <div className="form-group mt-3 mt-md-0">
                  <div className="row">
                    <div className="col">
                      <TextField
                        label="Day"
                        name="day1"
                        value={day1}
                        onChange={handleDay1Change}
                        sx={{
                          width: "70px",
                          ml: "10px",
                          bgcolor: "#f9f9f9",
                        }}
                        size="small"
                        color="success"
                      />
                      <TextField
                        label="Hour"
                        name="hour1"
                        value={hour1}
                        onChange={handleHour1Change}
                        sx={{
                          width: "70px",
                          ml: "10px",
                          bgcolor: "#f9f9f9",
                        }}
                        size="small"
                        color="success"
                      />
                      <TextField
                        label="minute"
                        name="minute1"
                        value={minute1}
                        onChange={handleMinute1Change}
                        sx={{
                          width: "70px",
                          ml: "10px",
                          bgcolor: "#f9f9f9",
                        }}
                        size="small"
                        color="success"
                      />
                      <TextField
                        label="second"
                        name="second1"
                        value={second1}
                        onChange={handleSecond1Change}
                        sx={{
                          width: "70px",
                          ml: "10px",
                          bgcolor: "#f9f9f9",
                        }}
                        size="small"
                        color="success"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12 col-md-4">
                <div style={{ marginRight: "40px" }}>
                  <FormControlLabel
                    value="add"
                    control={
                      <Radio
                        color="success"
                        checked={type === "add"}
                        onChange={(e) => setType(e.target.value)}
                      />
                    }
                    label="Add +"
                    labelPlacement="start"
                  />
                  <FormControlLabel
                    value="subtract"
                    control={
                      <Radio
                        color="success"
                        checked={type === "subtract"}
                        onChange={(e) => setType(e.target.value)}
                      />
                    }
                    label="Subtract -"
                    labelPlacement="start"
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12 col-md-4">
                <div className="form-group mt-3 mt-md-0">
                  <div className="row">
                    <div className="col">
                      <TextField
                        label="Day"
                        name="day2"
                        value={day2}
                        onChange={handleDay2Change}
                        sx={{
                          width: "70px",
                          ml: "10px",
                          bgcolor: "#f9f9f9",
                        }}
                        size="small"
                        color="success"
                      />
                      <TextField
                        label="Hour"
                        name="hour2"
                        value={hour2}
                        onChange={handleHour2Change}
                        sx={{
                          width: "70px",
                          ml: "10px",
                          bgcolor: "#f9f9f9",
                        }}
                        size="small"
                        color="success"
                      />
                      <TextField
                        label="Minute"
                        name="minute2"
                        value={minute2}
                        onChange={handleMinute2Change}
                        sx={{
                          width: "70px",
                          ml: "10px",
                          bgcolor: "#f9f9f9",
                        }}
                        size="small"
                        color="success"
                      />
                      <TextField
                        label="Second"
                        name="second2"
                        value={second2}
                        onChange={handleSecond2Change}
                        sx={{
                          width: "70px",
                          ml: "10px",
                          bgcolor: "#f9f9f9",
                        }}
                        size="small"
                        color="success"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col text-center">
                <br />
                <div className="mb-3">
                  <Button
                    onClick={handleCalculateTime}
                    color="success"
                    sx={{
                      backgroundColor: "rgb(25,135,84)",
                      fontSize: "15px",
                      marginRight: "25px",
                      padding: "5px 25px",
                      color: "white",
                    }}
                  >
                    Calculate
                  </Button>
                  <Button
                    sx={{
                      backgroundColor: "rgb(108,117,125)",
                      fontSize: "15px",
                      marginRight: "25px",
                      padding: "5px 25px",
                      color: "white",
                    }}
                    onClick={() => {
                      setDay1("");
                      setHour1("");
                      setMinute1("");
                      setSecond1("");
                      setDay2("");
                      setHour2("");
                      setMinute2("");
                      setSecond2("");
                      setType("add");
                      setResultDay("");
                      setResultHour("");
                      setResultMinute("");
                      setResultSecond("");
                    }}
                  >
                    Clear
                  </Button>
                </div>
              </div>
              <hr />
              <div className="row">
                <div className="col">
                  {resultSecond && (
                    <TableContainer component={Paper}>
                      <Table>
                        <TableHead>
                          <TableRow style={{ backgroundColor: "#4caf50" }}>
                            <TableCell
                              style={{ color: "white", textAlign: "center" }}
                            >
                              Day
                            </TableCell>
                            <TableCell
                              style={{ color: "white", textAlign: "center" }}
                            >
                              Hour
                            </TableCell>
                            <TableCell
                              style={{ color: "white", textAlign: "center" }}
                            >
                              Minute
                            </TableCell>
                            <TableCell
                              style={{ color: "white", textAlign: "center" }}
                            >
                              Second
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          <TableRow>
                            <TableCell style={{ textAlign: "center" }}>
                              {resultDay}
                            </TableCell>
                            <TableCell style={{ textAlign: "center" }}>
                              {resultHour}
                            </TableCell>
                            <TableCell style={{ textAlign: "center" }}>
                              {resultMinute}
                            </TableCell>
                            <TableCell style={{ textAlign: "center" }}>
                              {resultSecond}
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </TableContainer>
                  )}
                  <br />
                </div>
              </div>
              <hr />
              <div className="row">
                <RelatedLinks />
                <br />
                <hr />
              </div>
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList
            CalculatorsTypeId={CalculatorsType.humanCalculators}
          ></MainCalculatorsList>
          <br />
        </div>
         </div>
</div>
  );
}
export default TimeCalculator;